import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useState } from 'react';
import { FileIcon, X } from 'lucide-react';
import { bytesToHumanReadable, cn } from '@fortem-monorepo/js-utilities';
export const FileUploadInput = forwardRef(({ files, setValue, placeholder, loading = false, multiple = true, ...props }, forwardedRef) => {
    const [isDraggingOver, setIsDraggingOver] = useState(false);
    const handleDropFiles = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setValue(e.dataTransfer.files);
        setIsDraggingOver(false);
    };
    const removeFileAtIndex = (index) => {
        const fileArray = Array.from(files ?? []);
        fileArray.splice(index, 1);
        const _newFileList = new DataTransfer();
        fileArray.forEach((file) => _newFileList.items.add(file));
        setValue(_newFileList.files);
    };
    const handleChange = (e) => {
        // Prevent cancel event with native dialog removing
        // all currently selected files
        if (!e.target.files?.length) {
            e.preventDefault();
            return;
        }
        if (props.onChange) {
            props.onChange(e);
        }
    };
    return (_jsxs("div", { className: cn('relative [&:hover:not(:has(.file-list:hover,.upload-button:hover))]:border-neutral-500 flex items-center justify-center border-dashed border-neutral-300 border-2 rounded-md transition-colors overflow-hidden w-full min-h-20 p-4', {
            ['border-neutral-800']: isDraggingOver,
            ['pointer-events-none cursor-not-allowed opacity-50']: loading || props.disabled,
        }), onDrop: handleDropFiles, onDragOver: (e) => {
            // ---------- This stops opening files in a new tab
            e.preventDefault();
            // ----------
            setIsDraggingOver(true);
        }, onDragLeave: () => {
            setIsDraggingOver(false);
        }, children: [_jsx("label", { className: cn('absolute w-full h-full top-0 left-0 cursor-pointer'), onClick: (e) => {
                    e.stopPropagation();
                }, children: _jsx("input", { ref: forwardedRef, ...props, type: "file", multiple: multiple, onChange: handleChange, className: 'hidden' }) }), files?.length ? (_jsx("div", { className: 'w-full max-w-full flex justify-center flex-col gap-1 file-list', children: Array.from(files).map((file, index) => {
                    return (_jsxs("div", { className: 'py-1 grid grid-cols-[5fr_2fr_2fr_1fr] items-center gap-4 px-2 rounded-md border text-sm text-neutral-700 z-10', children: [_jsx("span", { className: 'flex-4 shrink whitespace-nowrap text-ellipsis overflow-hidden', children: file.name }), _jsx("span", { className: 'flex-1 whitespace-nowrap', children: bytesToHumanReadable(file.size) }), _jsx("span", { className: 'flex-1 whitespace-nowrap  overflow-hidden text-ellipsis', children: file.type }), _jsx("span", { className: 'flex items-center', children: _jsx("button", { className: 'cursor-pointer rounded-md [group-hover]:hover:bg-neutral-500 transition-colors ml-auto', onClick: (e) => {
                                        e.preventDefault();
                                        removeFileAtIndex(index);
                                    }, children: _jsx(X, { className: 'text-red-600 pointer-events-none', strokeWidth: 1, size: 20 }) }) })] }, index));
                }) })) : (_jsxs("span", { className: 'pointer-events-none flex gap-2 items-center text-sm text-muted-foreground', children: [_jsx(FileIcon, { size: 18 }), " Drag and drop files or click to upload"] }))] }));
});
